<template lang="pug">
  .component-policy-button
    .dropdown-buttons
      PageReveal(:item="item")
      ActionButton(:action="remove", confirm) Delete
      a.button(:href="appUrl", target="_blank") Preview

</template>

<script>
import ActionButton from '../ActionButton'
import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
import MaggieHelper from '../../../../maggieHelper'
import PageReveal from "../../../../pages/backoffice/EditPageReveal.vue";
import {EventBus} from "../../../../eventBus";
import {mapState} from "vuex";

/**
 * route name route path
 *
 */
export default {
  name: 'PageButtons',
  components: {PageReveal, ActionButton},
  data() {
    return {}
  },
  created() {
  },
  methods: {
    preview() {
      return this.configuration.company.company_start_url.value.replace('registration?client_token=', '')
    },
    remove() {
      return KeplerBackofficeSdk.pages.select(this.item.id).remove(() => {
        MaggieHelper.notification('', 'Policy deleted')
        EventBus.$emit('reload-list')
      })
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    appUrl(){
      return this.configuration.company.company_start_url.value.replace('registration?client_token=', `pages/${this.item.slug}`)
    }
  },
  props: ['item']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PageButtons.vue?35a71efa